import { Component } from "@angular/core";
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: "app-license-expired-modal",
  templateUrl: "./license-expired-modal.component.html",
  styleUrls: ["./license-expired-modal.component.scss"],
})
export class LicenseExpiredModalComponent {
    constructor(private dialogRef: MatDialogRef<LicenseExpiredModalComponent>) {}

    ngOnInit() {
        console.log("License expired modal initialized");
    }

    close() {
        console.log("License expired modal closed");
        this.dialogRef.close(true);
    }
}